"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedRoute = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const auth0_react_1 = require("@auth0/auth0-react");
const react_router_dom_1 = require("react-router-dom");
const auth_1 = require("../util/auth");
const ProtectedRoute = ({ needsAdmin, children }) => {
    const { user, isAuthenticated } = (0, auth0_react_1.useAuth0)();
    if (!isAuthenticated) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/", replace: true });
    }
    if (needsAdmin && !(0, auth_1.isAdmin)(user)) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: "/", replace: true });
    }
    return children ?? null;
};
exports.ProtectedRoute = ProtectedRoute;
